import { useCityInfoStore } from '~/stores/useCityInfo'

export default (nuxtApp: any) => {
  const { _route: { fullPath, params } } = nuxtApp
  const domain = params?.domain ?? ''
  const store = useCityInfoStore()
  const { baiduKey, baiduKeyGa } = store
  // 过滤会员中心&搜索板块统计
  const pattern = /\/member\/\w+|\/\w+\/search\/\w+/
  const filter = pattern.test(fullPath)
  if (!filter && process.env.NODE_ENV === 'production') {
    // 公共统计代码pc&m
    (function () {
      const keys = [

        {
          id: 'baidu_tj_pc',
          url: 'https://hm.baidu.com/hm.js?d8e1ca741719222e7bdea1581ab95414',
        },
        // {
        //   id: 'baidu_tj_m',
        //   url: 'https://hm.baidu.com/hm.js?b70b48b4c6042b985978452a4665a4d8',
        // },
      ]
      // eslint-disable-next-line array-callback-return
      keys.map((i) => {
        document.getElementById(i.id) && document.getElementById(i.id).remove()
        const hm = document.createElement('script')
        hm.src = i.url
        hm.id = i.id
        const s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })
    })()

    // 普通站点
    if (baiduKey) {
      // var _hmt = _hmt || [];
      (function () {
        document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove()
        const hm = document.createElement('script')
        hm.src = `https://hm.baidu.com/hm.js?${baiduKey}`
        hm.id = 'baidu_tj'
        const s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })()
    }

    // 固安站点额外添加
    if (domain === 'lfga' && !!baiduKeyGa) {
      (function () {
        document.getElementById('baidu_tj_ga') && document.getElementById('baidu_tj_ga').remove()
        const hm = document.createElement('script')
        hm.src = `https://hm.baidu.com/hm.js?${baiduKeyGa}`
        hm.id = 'baidu_tj_ga'
        const s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })()
    }
  }
}
